<template>
	<div >
		<div class="mecon-container-padding" style="padding-bottom:70px;" v-if="memberList.length">
			<!-- <div class="meconheader">共{{memberList.length}}成员 男 {{boy}} 女{{girl}}</div> -->
			<div class="meconbody" v-for="item in memberList" :key="item.id">
				<div :class="['radiusshadow mecon-container-padding', item.sex == '男' ? 'man' : 'girl' ]">
					<div>
						<div>{{item.name}}</div>
						<div>{{item.mobile}}</div>
					</div>
					<div>
						<Button class="mvbuttonplain" plain type="warning" size="mini" round @click="delmember(item)">删除</Button>
						<Button class="mvbuttonplain" plain type="warning" size="mini" round @click="addMember(item)">修改</Button>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="line">
			<Divider>暂无数据</Divider>
		</div>
		<div class="meconfooter mecon-container-padding footer">
			<Button  type="warning" round @click="addMember(item = false)" >添加参赛卡</Button>
		</div>
	</div>
</template>

<script>
	import './mycontacts.less'
    import {mymemberlist,deletemember} from '@/libs/api'
    import {Button,Dialog,Divider} from 'vant'
    import {setStorage, getStorage} from '@/libs/utils'

    export default {
        name: 'mainapply',
        components: {
            Button,
            Divider
        },
		data() {
			return {
				postparams: {},
				memberList: {},
				registermatchinfo: {},
				boy: 0,
				girl: 0
			}
		},
		methods:{
			delmember(item){
				Dialog.confirm({
					title: '提示',
					message: '确定删除该成员？'
				}).then(() => {
					let params = {}
					params.memberid = item.memberid
					params.urid = this.postparams.urid
					params.token = this.postparams.token
					deletemember(params).then((res)=>{
						if(res.status==200)
						{
							this.memberlist()
						}
					})
				});
			},
			addMember(item){
				var memberid = ''
				var attrs = ''
				if(item){
					memberid = item.memberid
					attrs = item
					setStorage('contacts', attrs, true);
				}
				//缓存
				try{    
					//跳转 url
					this.$router.push({name:'myconedit',memberid:memberid});
				}catch(e)
				{
					// console.log(111);
				}		                		
			},
			memberlist(){
				mymemberlist(this.postparams).then((res) => {
					if (res.status == 200 && res.data && res.data.list) {

						var boy = 0, girl = 0;
						res.data.list.forEach((item) => {


							item.memberinfos    =   JSON.parse(item.memberinfos);

							item.memberinfos.forEach((citem) => {
								if (citem.key_name == 'mv_name') {
									item.name = citem.value;
								}
								if (citem.key_name == 'mv_mobile') {
									item.mobile = citem.value;
								}
								if (citem.key_name == 'mv_sex') {
									item.sex = citem.value;
									if (item.sex == '男') {
										boy++;
									}
									if (item.sex == '女') {
										girl++;
									}
								}

							})

							item.attrs = JSON.stringify(item.attrs);
						})
						this.memberList = res.data.list
						this.boy = boy
						this.girl = girl
					}else{
						this.memberList = {}
						this.boy = 0
						this.girl = 0
					}
				})
			}
		},
		mounted() {
			this.$nextTick(() => {
				let userinfo = getStorage('userInfo')
				this.postparams.urid = userinfo.urid
				this.postparams.token = userinfo.token
				this.memberlist()
			})
		}
        
    }
</script>